import CandidateDetailsCard from "./candidateDetailsCard";
export default CandidateDetailsCard;